import HttpService from "../services/Http.Service";
async function getAccount(data) {
    return await HttpService.controlServerWithToken("GET", "auth", "get_account", data);
}

async function getAccountByToken(data) {
    return await HttpService.controlServerWithToken("GET", "auth", "get_account_by_token", data);
}

async function getAuthorizedAccountsByRoom(data) {
    return await HttpService.controlServerWithToken("GET", "auth", "get_authorized_accounts_by_room", data);
}

async function logIn(data) {
    return await HttpService.controlServer("POST", "auth", "log_in", data);
}

async function resetAccount(data) {
    return await HttpService.controlServerWithToken("POST", "auth", "reset_account", data);
}

async function updatePassword(data) {
    return await HttpService.controlServerWithToken("POST", "auth", "update_password", data);
}

async function createAccount(data) {
    return await HttpService.controlServerWithToken("POST", "auth", "create_account", data);
}

async function updateAccount(data) {
    return await HttpService.controlServerWithToken("POST", "auth", "update_account", data);
}

async function deleteAccount(data) {
    return await HttpService.controlServerWithToken("POST", "auth", "delete_account", data);
}

async function addAuthorization(data) {
    return await HttpService.controlServerWithToken("POST", "auth", "add_authorization", data);
}

async function deleteAuthorization(data) {
    return await HttpService.controlServerWithToken("POST", "auth", "delete_authorization", data);
}

export {
    getAccount,
    getAccountByToken,
    getAuthorizedAccountsByRoom,
    logIn,
    resetAccount,
    updatePassword,
    createAccount,
    updateAccount,
    deleteAccount,
    addAuthorization,
    deleteAuthorization,
};
